// Copyright (c) Docugami, Inc. All rights reserved.

import { IList, IListProps, List } from "@fluentui/react"
import styled from "styled-components"
import { useRef } from "react"
import { ISuggestedChunk } from "hooks/WorkPathSuggestedChunks"
import { ReportSuggestedItemCardlet } from "./ReportsSuggestedItemCardlet"
import { DisabledCss } from "components/common/DgCommonStyledComponents"

const ListRoot = styled.div<{ disabled?: boolean }>`
    flex: 1;
    display: flex;
    width: 100%;
    flex-direction: column;
    ${props => !!props.disabled && DisabledCss}
`

const SuggestedItemRoot = styled.div`
    margin-top: 5px;
`

export interface ISuggestedItemListItem {
    suggestion: ISuggestedChunk;
    footer: JSX.Element;
}

interface SuggestedItemsListProps<T = any> extends IListProps<T> {
    docSetId: string;
    documentId: string;
    dndDisabled: boolean;
    disabled?: boolean;
}

export function SuggestedItemsList<ISuggestedItemListItem>(props: SuggestedItemsListProps<ISuggestedItemListItem>): JSX.Element {
    const listRef = useRef<IList | null>(null);

    function onRenderItem(item?: ISuggestedItemListItem, index?: number, isScrolling?: boolean): React.ReactNode {
        if (!item || index === undefined) {
            return null;
        }

        // @ts-ignore
        const cardlet = <ReportSuggestedItemCardlet suggestion={item.suggestion} footer={item.footer}
            clusterId={props.docSetId}
            documentId={props.documentId}
            dndDisabled={props.dndDisabled} />
        return <SuggestedItemRoot>{cardlet}</SuggestedItemRoot>
    }

    return (
        <ListRoot disabled={props.disabled}>
            <List
                componentRef={listRef}
                items={[...(props.items!)]}
                onRenderCell={onRenderItem}
                onShouldVirtualize={() => false} />
        </ListRoot>
    )
}
